export class Template {
    public templateId: number;
    public accountingFirmId: number;
    public templateName: any;
    public category: any;
    public entityTypeId: number;
    public jobTypeId: number;
    public categoryId: number;
    public financialYear: any;
    public applicableDate:Date;
    public tag: any;
    public description: any;
    public _template: any = "";
    public isDeleted: any = false;
}

export class AddeditTemplate {
  TemplateCategoryName: any;
  TemplateCategoryId: any;
  Content: any;
  TemplateName: any;
  TempleteData: string;
  Status: string;
  public description: any;
  public isDefault: boolean = false;
  TemplateId: any;
  billingEntityId: string;
  billingEntityName: string;
}

export class FilterModel {
  public template: any
  public category: any
  public user: any
  public date: any
}

export class NarrationModels {
  public id: number
  public narrationId: any = '';
  public description: string
  public jobTypeId: any = undefined;
  public entityTypeId: any = undefined;
  public status: any = false;
  public type: any
  public updatedAt: any
  public updatedBy: string
  public isArchived: boolean
  public jobTypeName: string
  public entityTypeName: string
}

export class SfdtHtmlMergeRequest {
  SFDT!: string;
  MergeList!: { Field: string, Value: string }[]
}
